/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_MailtoInputs */

const en_enum_custom_property_link_rule_type_mailto = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_MailtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Mailto`)
};

const de_enum_custom_property_link_rule_type_mailto = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_MailtoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mail Link`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Mailto" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_MailtoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_mailto = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_MailtoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_MailtoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_mailto(inputs)
	return de_enum_custom_property_link_rule_type_mailto(inputs)
});